import { render, staticRenderFns } from "./KitMetricGraphChart.vue?vue&type=template&id=be313f54"
import script from "./KitMetricGraphChart.vue?vue&type=script&lang=ts"
export * from "./KitMetricGraphChart.vue?vue&type=script&lang=ts"
import style0 from "./KitMetricGraphChart.vue?vue&type=style&index=0&id=be313f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports